import React from 'react';
import IReadingButton from '@/components/interfaces/graphql/HtmlElement/ReadingButton';
import { locale } from 'i18n-js';

interface ReadingButtonProps {
  readingButton: IReadingButton;
}

const ReadingButton = ({
  readingButton: {
    data: { backgroundColor = 'green', buttonMaxWidth, buttonTextEn, buttonTextEs, sectionIds, sectionType },
  },
}: ReadingButtonProps) => (
  <span>
    <span contentEditable={false} data-button-type="reading" data-section-type={sectionType}>
      <span
        aria-label={`Open Reading: ${locale === 'es' ? (buttonTextEs || buttonTextEn) : buttonTextEn}`}
        className="btn reading-btn"
        data-background-color={backgroundColor}
        data-button-text-en={buttonTextEn}
        data-button-text-es={buttonTextEs || buttonTextEn}
        data-html-element-type="ReadingButton"
        data-section-ids={sectionIds.join(',')}
        role="button"
        style={{ maxWidth: buttonMaxWidth }}
        tabIndex={0}
      />
    </span>
  </span>
);

export default ReadingButton;
